module.exports = __webpack_public_path__ + "img/12_Proximal Descending Colon.90eb1ffa.png";